import { useTranslations } from 'next-intl';
import { CatHeading } from 'components/blocks-components';
import { NO_EXACT_MATCH_IMAGE, PAGE_BREAKPOINTS } from 'constants/common';
import { Image } from 'components/image';
import cx from 'classnames';
import styles from '../request-equipment-service-search.module.scss';
import { Conditional, useBreakpoint } from '@cat-ecom/pcc-components';
import { NO_EQUIPMENT_IMAGE } from 'components/request-equipment-service/constant';

const EquipmentSearchNoResults = () => {
  const t = useTranslations();
  const isMD = useBreakpoint(PAGE_BREAKPOINTS.MD);
  const headingVariant = isMD ? 'label' : 'label-lg';
  const noResultsContainer = cx({
    [styles['no_result_container']]: isMD,
    [`${styles['no_result_height']} justify-content-center d-flex flex-column align-items-center`]:
      !isMD
  });

  return (
    <div className={noResultsContainer}>
      <div>
        <Conditional test={!isMD}>
          <Image
            alt={NO_EXACT_MATCH_IMAGE.alt}
            src={NO_EXACT_MATCH_IMAGE.src}
            width={NO_EQUIPMENT_IMAGE.WIDTH}
            height={NO_EQUIPMENT_IMAGE.HEIGHT}
            loading="lazy"
            className={styles['image_container']}
          />
        </Conditional>
        <CatHeading variant={headingVariant}>
          <div className="pt-sm-0 pt-2 d-sm-inline d-flex justify-content-center u-color--Black">
            {t('NO_RESULTS_FOUND')}
          </div>
        </CatHeading>
      </div>
    </div>
  );
};

export default EquipmentSearchNoResults;
